// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"346":"97d3ae65","940":"aa490095"}[chunkId] + ".js";
};